import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Customform from "./CustominterviewForm.js";
import AWS from "../../../utils/awsConfig.js";
import { MODE } from "../../../constants/SiteConstants";

const API_URL = process.env.REACT_APP_API_URL;

const fields = [
  { label: "Name", name: "name", placeholder: "Enter Name", required: true },
  { label: "Company Name", name: "companyName", placeholder: "Enter Company Name", required: true },
  { label: "Website", name: "website", placeholder: "Enter Website URL" },
  { label: "Description", name: "description", placeholder: "Enter Description", type: "rich-text", required: true },
  { label: "Interview Date", name: "interviewDate", placeholder: "Select Interview Date", type: "date", required: true },
  { label: "Image", name: "image", placeholder: "Upload Image", type: "file" },
];

const InterviewForm = () => {
  const { id } = useParams();
  const [initialData, setInitialData] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const loadInterviewData = async () => {
        try {
          const response = await axios.get(`${API_URL}/interview/getInterviewById/${id}`);
          const interviewData = response.data;
          setInitialData(interviewData);
          setImagePreview(interviewData.image || null);
        } catch (error) {
          console.error("Error fetching interview data:", error);
          toast.error("Failed to load interview data");
        }
      };
      loadInterviewData();
    }
  }, [id]);

const handleImageUpload = async (file) => {
  if (!file) {
    toast.error("No file selected!");
    return null;
  }

  const formData = new FormData();
  formData.append("image", file);

  try {
    const response = await fetch(`${API_URL}/image/upload`, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || "Upload failed");
    }

    return data.imageUrl;
  } catch (error) {
    console.error("Upload Error:", error);
    toast.error("Error uploading image: " + error.message);
    return null;
  }
};



  const handleSubmit = async (formData) => {
    try {
      let uploadedImage = imagePreview;

      if (imageFile) {
        uploadedImage = await handleImageUpload(imageFile);
      }

      const updatedFormData = {
        ...formData,
        image: uploadedImage || null,
        interviewDate: new Date(formData.interviewDate),
      };

      console.log("Submitting Form Data:", updatedFormData);

      toast.info(id ? "Updating interview..." : "Adding interview...", { autoClose: 1000 });

      const response = id
        ? await axios.put(`${API_URL}/interview/updateInterview/${id}`, updatedFormData)
        : await axios.post(`${API_URL}/interview/createInterview`, updatedFormData);

      if (response.status === 200 || response.status === 201) {
        toast.success(`Interview ${id ? "updated" : "added"} successfully`, { autoClose: 1000 });
        navigate("/interview");
      } else {
        toast.warn("Operation completed with warnings", { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Form Submission Error:", error);
      const errorMessage = error.response?.data?.message || "An error occurred while processing";
      toast.error(`Error: ${errorMessage}`, { autoClose: 2000 });
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };





  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          {id ? "Update" : "Add"} Interview
        </h3>
        <button className="form-close-btn" onClick={() => navigate("/interviewManagement")}> &times; </button>
      </div>
      <Customform
        mode={id ? MODE.UPDATE : MODE.ADD}
        onSubmit={handleSubmit}
        fields={fields}
        initialData={initialData || {}}
        imagePreviews={imagePreview ? [imagePreview] : []}
        handleImageChange={handleImageChange}
      />
    </div>
  );
};

export default InterviewForm;
